import { axiosAPIInstance as axios } from '../../axios-config';

const state = {
  activeGameSetGames: [],
  hasLoadedActiveGameSet: false
};

const mutations = {
  setActiveGameSetGames(state, payload) {
    state.activeGameSetGames = payload;
    state.hasLoadedActiveGameSet = true;
  }
};

const getters = {
  cachedActiveGameSetGames(state) {
    return state.activeGameSetGames;
  }
};

const actions = {
  async getShouldDefaultToHub({ dispatch, rootGetters }) {
    const me = rootGetters.me;
    if (me.roles.some(r => ['student', 'employee'].includes(r._id)) && (me.assignedGame.length + me.classes.length === 1)) {
      const list = await dispatch('getActiveGameSetGames');
      if (
        list.length === 0
        || (list.length === 1 && me.assignedGame.some(a => a._id === list[0]._id))
      ) {
        return false;
      }
    }
    return true;
  },

  async createGameSet(_, gameSet) {
    const response = await axios.post('/blade/gamesets', gameSet);
    return response.data.gameSet;
  },
  async getGameSet(_, { gameSetId }) {
    const response = await axios.get(`/blade/gamesets/${gameSetId}`);
    return response.data;
  },
  async getGameSets() {
    const response = await axios.get('/blade/gamesets');
    return response.data.gameSets;
  },
  async getActiveGameSetGames({ commit, state }, { getAll, shouldRefresh } = {}) {
    if (!state.hasLoadedActiveGameSet || shouldRefresh) {
      const response = await axios.get(`/blade/gamesets/active${getAll ? '?getAll=true' : ''}`);
      commit('setActiveGameSetGames', response.data.games);
      return response.data.games;
    }
    return state.activeGameSetGames;
  },
  async updateGameSet(_, game) {
    const response = await axios.patch(`/blade/gamesets/${game._id}`, game);
    return response.data.gameSet;
  },
  async deleteGameSet(_, { _id, gameSetId }) {
    const did = _id || gameSetId;
    const response = await axios.delete(`/blade/gamesets/${did}`);
    return response.data.gameSet;
  },
};

export default {
  state,
  getters,
  mutations,
  actions
};



// WEBPACK FOOTER //
// ./src/store/blade/gamesets.js